var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevDownDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99984 5.99999L0.756836 1.75699L2.17184 0.342987L4.99984 3.17199L7.82784 0.342987L9.24284 1.75699L4.99984 5.99999Z",
    fill: "#6D6D73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevDownDark);
export default __webpack_public_path__ + "static/media/chev-down-dark.3eca7dd96dbcdec0f137cff9c2fb3e3f.svg";
export { ForwardRef as ReactComponent };